import { createApiService, RestApiOptions } from './api';

export const createServices = (options: RestApiOptions) => ({
    resDiary: createApiService(options),
});
